import { makeAutoObservable } from 'mobx'
import { type CountryCode } from 'libphonenumber-js'

export class CountriesStore {
  private _selectedCountries: CountryCode[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get selectedCountries() {
    return this._selectedCountries
  }

  get isNextDisabled() {
    return !this._selectedCountries.length
  }

  isCountryActive = (country: CountryCode) => this._selectedCountries.includes(country)

  toggleCountry = (country: CountryCode) => {
    this._selectedCountries = this.isCountryActive(country)
      ? this._selectedCountries.filter((item) => item !== country)
      : [...this._selectedCountries, country]
  }

  reset = () => {
    this._selectedCountries = []
  }
}
